'use client'

import styled from 'styled-components'

export const Wrapper = styled.a<{ isActive: boolean }>`
  color: #5b5675;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  width: 33%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${(props) =>
    props.isActive &&
    `background: #F8F7FC;
    color:#040222;
  border-bottom: 3px solid #33BA75;
  `};
`
